document.addEventListener('turbolinks:load', function() {
});

  console.log('shops show');    

  var swiper_shop_photos = new Swiper('.shop-photos-container', {
    loop: true,
    autoplay: {
    delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  var swiper_recommends = new Swiper('.recommends-container', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: '.recommends-container-swiper-button-next',
          prevEl: '.recommends-container-swiper-button-prev'
        }
      }
    }
  })

  var swiper_other_stalls = new Swiper('.other-stalls-container', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
        navigation: {
          nextEl: '.other-stalls-container-swiper-button-next',
          prevEl: '.other-stalls-container-swiper-button-prev'
        }
      }
    }
  })

  var swiper_nearby = new Swiper('.nearby-container', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
        navigation: {
          nextEl: '.nearby-container-swiper-button-next',
          prevEl: '.nearby-container-swiper-button-prev'
        }
      }
    }
  })

  // Tooltip
  const tooltip_rating_all = document.getElementById('rating_all');
  if (tooltip_rating_all != null) {
    tippy('#rating-all', {
      placement: 'bottom',
      theme: 'material',
      content: tooltip_rating_all.innerHTML,
      allowHTML: true,
    })
  }

  const tooltip_info_pictogram = document.getElementById('info_pictogram');
  tippy('#info-pictogram', {
    placement: 'bottom',
    theme: 'material',
    content: tooltip_info_pictogram.innerHTML,
    allowHTML: true,
  })

  /// Clipboard - URL
  var clipboard_url = new ClipboardJS('.copy-value-url');
  var btns_url = document.querySelectorAll('.copy-value-url');
  for(let i=0;i<btns_url.length;i++){
    btns_url[i].addEventListener('mouseleave',clearTooltipUrl);
  }
  function clearTooltipUrl(e){
    e.currentTarget.setAttribute('class','fa-layers fa-fw copy-value-url');
  }
  function showTooltipUrl(elem){
    elem.setAttribute('class','fa-layers fa-fw copy-value-url tooltip_copied');
  }
  clipboard_url.on('success', function(e) {
    showTooltipUrl(e.trigger);
  });

  //// Clipboard - Address
  var clipboard_address = new ClipboardJS('.copy-value-address');
  var btns_address = document.querySelectorAll('.copy-value-address');
  for(let i=0;i<btns_address.length;i++){
    btns_address[i].addEventListener('mouseleave',clearTooltipAddress);
  }
  function clearTooltipAddress(e){
    e.currentTarget.setAttribute('class','fa-layers fa-fw copy-value-address');
  }
  function showTooltipAddress(elem){
    elem.setAttribute('class','fa-layers fa-fw copy-value-address tooltip_copied');
  }
  clipboard_address.on('success', function(e) {
    showTooltipAddress(e.trigger);
  });


